<template>
    <app-content-admin>
        <template slot="header">Project</template>
        <template slot="button">
            <v-btn
            style="margin-left:auto"
            large
            color="primary"
            to="/project/add_project"
            >
            + Add Project
        </v-btn>

        </template>

        
        <v-layout row wrap>
           
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Id</th>
                            <th scope="col">Project Name</th>
                            <th scope="col">Project Id</th>
                            <th scope="col">Project Number</th>   
                            <th scope="col">Action</th>                       
                        </thead>
                        <tbody>
                            <tr class="text-center" v-for="row in rows" :key="row.id_project">
                                <td :data-label="$t('id_project')">{{ row.id_project }}</td>
                                <td :data-label="$t('firebase_project_name')" class="text-truncate">{{ row.firebase_project_name }}</td>
                                <td :data-label="$t('firebase_project_id')">{{ row.firebase_project_id }}</td>
                                <td :data-label="$t('firebase_project_number')" class="text-truncate">
                                    {{ row.firebase_project_number }}
                                </td>                              
                                <td :data-label="$t('action')">
                                    <v-menu :close-on-content-click="true" :nudge-width="200" :open-on-click="true" offset-y
                                        offset-x left>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" text small icon v-on="on">
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="editProject(row.id_project)">
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item @click="deleteProject(row.id_project)">
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <v-layout justify-center>
                        <v-flex xs8>
                            <div class="text-xs-center" v-if="pages > 0">
                                <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
                            </div>
                        </v-flex>
                    </v-layout> -->
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'

export default {
    mixins: [vForm],

    data(){
        return {              
              rows:[],
              pages:0,
              page:1,
              form: {
                  page: 1,
                  offset: 10,
              }              
          }
        },

        components: {ActiveLabel},

        created() {
            this.search();
        },

        methods: {
            search(offset = 10, page = 1) {
                this.form.offset = offset;
                this.form.page = page;

                let loader = this.$loading.show();
                let token = store.getters['auth/token'];
                axios.get(`/api/cloud/get_firebase_project_list?token=${token}`)
                    .then(res => res.data)
                    .then(res => {
                        this.rows = res.data.result;
                        //this.rows = res.data.data;
                        //this.pages = res.data.pages;
                     })
                    .catch((e)=>{
                        this.$toastr.e(e.message);
                    })
                    .finally(()=>{
                        loader.hide();
                    })
            },

            onListChange(page) {
                this.search(10, page);
            },

            async deleteProject(id) {
                let loader = this.$loading.show();

                try{
                 let token = store.getters['auth/token'];
                 let res = await axios.post(`/api/cloud/delete_firebase_project?token=${token}`,{id_project:id})
                    if(res.data){
                     this.$toastr.s("Delete successfully");
                    }
                }
                catch(e){
                    this.$toastr.e(e.message);
                }
                finally{
                    loader.hide();
                    this.search();
                }
            },  
            
            editProject(id)
            {
                this.$router.push({path:'/project/edit_project/'+ id})
            },
            
        }
}
</script>